import { supabase } from "@vincer/services/api/supabase";
import { Assignment, GetAssignmentsResult } from "@vincer/types";

/**
 * Fetches all assignments for the logged-in mentor
 */
export async function getMentorAssignments(
  userId: string
): Promise<GetAssignmentsResult> {
  try {
    // First, get the mentor UUID from the mentor table
    const { data: mentorData, error: mentorError } = await supabase
      .from("mentor")
      .select("uuid")
      .eq("user_uuid", userId)
      .single();

    if (mentorError) {
      console.error("Error fetching mentor data:", mentorError);
      return {
        success: false,
        error: "Could not find mentor record for this user",
      };
    }

    if (!mentorData) {
      return { success: false, error: "No mentor record found for this user" };
    }

    const mentorUuid = mentorData.uuid;

    // Fetch all assignments for this mentor
    const { data, error } = await supabase
      .from("relationship_assignments")
      .select(
        `
        uuid,
        start,
        end,
        mentee:mentee_uuid (
          uuid,
          vincer_base_user (
            name,
            email,
            job_title,
            company
          )
        )
      `
      )
      .eq("mentor_uuid", mentorUuid);

    if (error) {
      console.error("Error fetching assignments:", error);
      return { success: false, error: error.message };
    }

    if (!data || data.length === 0) {
      return { success: true, data: [] };
    }

    // Transform the data to match our Assignment interface
    const assignments: Assignment[] = data.map((item: any) => ({
      uuid: item.uuid,
      start: item.start,
      end: item.end,
      mentee: {
        uuid: item.mentee.uuid,
        name: item.mentee.vincer_base_user.name,
        email: item.mentee.vincer_base_user.email,
        jobTitle: item.mentee.vincer_base_user.job_title,
        company: item.mentee.vincer_base_user.company,
        avatar: "https://i.pravatar.cc/300",
      },
    }));

    return { success: true, data: assignments };
  } catch (error) {
    console.error("Unexpected error fetching assignments:", error);
    return {
      success: false,
      error:
        error instanceof Error ? error.message : "An unexpected error occurred",
    };
  }
}
